"use client";
import { jsxs, jsx } from "react/jsx-runtime";
import { useAgent } from "../../../../utils/agent/AgentProvider.js";
import { useRef, useEffect } from "react";
import { Box } from "@mui/material";
import { Link, Notification, Select, TextField } from "@nxt-costco-com/forge-components";
import { SpaceSm, SpaceLg } from "@nxt-costco-com/forge-design-tokens";
import { addToListActions, CREATE_LIST_OPTION } from "../constants.js";
import { ProductSimple } from "../../ProductSimple/index.js";
import { useAuth } from "../../../../hooks/auth/useAuth/index.js";
const AddToListModalBody = ({
  enableModernApis,
  state,
  dispatch,
  product,
  msStore
}) => {
  const {
    wishList,
    addToListModalMode,
    newListName,
    selectedListId,
    hasInputError,
    inputErrorText,
    showError,
    errorMsg,
    isLoading,
    quantity
  } = state;
  const { agent } = useAgent();
  const { getToken, isLoading: isAuthLoading } = useAuth();
  const textFieldInputRef = useRef();
  useEffect(() => {
    if (agent && !isAuthLoading) {
      const siteValue = msStore.getPropertiesItemsKeysItem(
        "clientid"
      );
      dispatch({
        payload: { isLoading: true },
        type: addToListActions.CHANGE_LOADING_STATE
      });
      const handleWishListError = (err) => {
        var _a, _b;
        const message = (_b = (_a = err == null ? void 0 : err.response) == null ? void 0 : _a.data) == null ? void 0 : _b.message;
        if (message && message !== "Lists do not exist") {
          console.error(`get Lists Api failure with error: ${err}`);
          dispatch({
            payload: {
              errorMsg: msStore.getKeyValueItem(
                "getlistapierrormessage"
              ),
              isLoading: false,
              showError: true
            },
            type: addToListActions.SHOW_ERROR
          });
        }
      };
      const getWishList = async () => {
        try {
          const authCookie = await getToken();
          const createNewWishListOption = {
            text: msStore == null ? void 0 : msStore.getKeyValueItem("newlistoption"),
            value: CREATE_LIST_OPTION
          };
          if (authCookie) {
            if (!enableModernApis) {
              agent.getWishListsLegacy().then((res) => {
                var _a;
                const wishList2 = (_a = res == null ? void 0 : res.shoppinglist) == null ? void 0 : _a.map(
                  (wishListItem) => ({
                    text: wishListItem.description,
                    value: wishListItem.listId
                  })
                );
                wishList2.push(createNewWishListOption);
                dispatch({
                  payload: {
                    clientIdLegacy: res.clientId,
                    isLoading: false,
                    wishList: wishList2
                  },
                  type: addToListActions.UPDATE_WISH_LIST
                });
              }).catch((err) => {
                handleWishListError(err);
              });
            } else {
              agent.getWishLists(authCookie, siteValue).then((res) => {
                const wishList2 = res == null ? void 0 : res.map(
                  (wishListItem) => ({
                    text: wishListItem.title,
                    value: wishListItem.id
                  })
                );
                wishList2.push(createNewWishListOption);
                dispatch({
                  payload: {
                    isLoading: false,
                    wishList: wishList2
                  },
                  type: addToListActions.UPDATE_WISH_LIST
                });
              }).catch((err) => {
                handleWishListError(err);
              });
            }
          } else {
            dispatch({
              payload: {
                isLoading: false,
                wishList: [createNewWishListOption]
              },
              type: addToListActions.UPDATE_WISH_LIST
            });
          }
        } catch {
          console.error("Token fetch failed");
        }
      };
      getWishList();
    }
  }, [agent, dispatch, enableModernApis, msStore, isAuthLoading, getToken]);
  useEffect(() => {
    var _a;
    if (addToListModalMode === addToListActions.CREATE_LIST) {
      (_a = textFieldInputRef == null ? void 0 : textFieldInputRef.current) == null ? void 0 : _a.focus();
    }
  }, [addToListModalMode]);
  if (addToListModalMode === addToListActions.UPDATED_TO_LIST) {
    const successmessage = msStore.getKeyValueItem("successmessage");
    const viewListUrl = msStore.getPropertiesItem("listPageURL");
    const successMessageArray = successmessage.split("{list name}");
    return /* @__PURE__ */ jsxs(Box, { children: [
      /* @__PURE__ */ jsx("span", { children: `${successMessageArray[0]}` }),
      /* @__PURE__ */ jsx(
        Link,
        {
          href: viewListUrl.replace("{listId}", selectedListId),
          uniqueId: `addToList_viewListUrl_${product.id}`,
          children: newListName
        }
      ),
      /* @__PURE__ */ jsx("span", { children: `${successMessageArray[1]}` })
    ] });
  }
  const listLabel = msStore.getKeyValueItem("listnamefieldlabel");
  const listdropdownlabel = msStore.getKeyValueItem("listdropdownlabel");
  const quantityerrormessage = msStore.getKeyValueItem(
    "quantityerrormessage"
  );
  return /* @__PURE__ */ jsxs(Box, { children: [
    showError && /* @__PURE__ */ jsx(
      Notification,
      {
        sx: {
          padding: SpaceSm
        },
        isRole: true,
        message: errorMsg,
        severity: "critical"
      }
    ),
    /* @__PURE__ */ jsx(
      Box,
      {
        sx: {
          padding: `${SpaceLg} 0`
        },
        children: /* @__PURE__ */ jsx(
          ProductSimple,
          {
            onQuantityChange: (val) => dispatch({
              payload: { quantity: val },
              type: addToListActions.UPDATE_QUANTITY
            }),
            customErrorMsg: !quantity ? quantityerrormessage : "",
            href: product.href,
            id: product.id,
            price: product.price,
            src: product.src,
            title: product.title
          }
        )
      }
    ),
    /* @__PURE__ */ jsxs(Box, { children: [
      addToListModalMode === addToListActions.ADD_TO_LIST && /* @__PURE__ */ jsx(
        Select,
        {
          onChange: (e) => {
            const selectedOptionText = (
              /* @ts-expect-error this is needed to get the text of the option */
              e.target.options[e.target.selectedIndex].text
            );
            dispatch({
              payload: {
                selectedList: selectedOptionText,
                selectedListId: e.target.value
              },
              type: addToListActions.UPDATE_SELECTED_LIST
            });
          },
          options: [
            {
              ariaHidden: true,
              disabled: true,
              text: "",
              value: ""
            },
            ...wishList
          ],
          errorText: inputErrorText,
          hasError: hasInputError,
          isLoading,
          label: listdropdownlabel,
          value: selectedListId
        }
      ),
      addToListModalMode === addToListActions.CREATE_LIST && /* @__PURE__ */ jsx(
        TextField,
        {
          onChange: (e) => {
            dispatch({
              payload: { newListName: e.target.value },
              type: addToListActions.UPDATE_NEW_LIST_NAME
            });
          },
          onKeyDown: (e) => {
            if (e.key !== "Escape") {
              e.stopPropagation();
            }
          },
          errorText: inputErrorText,
          id: "test",
          inputRef: textFieldInputRef,
          isError: hasInputError,
          label: listLabel,
          value: newListName
        }
      )
    ] })
  ] });
};
export {
  AddToListModalBody
};
